import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
    setConsent,
} from "firebase/analytics";
import { darkGreen, lightGreen, theme } from "../Resources/Design/theme";
import { Motion } from "./Motion";
import { Link } from "react-router-dom";
import { pastelOrange } from "../Pages/Main/constants";



const fullConsent = {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
};

// Consent Required Always
const partialConsent = {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "denied",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
};

function sklikAnonymousRetargeting(allowed = false) {
    if (!window?.rc?.retargetingHit) return;
    var retargetingConf = {
        rtgId: 86687,
        consent: allowed ? 1 : 0,
    };
    window.rc.retargetingHit(retargetingConf);
}

export function setDefaultConsent() {
    sklikAnonymousRetargeting(false);
    setConsent(partialConsent);
    if (window?.gtag) {
        window.gtag("consent", partialConsent);
    }
    if (window?.fbq) {
        window.fbq("consent", "revoke");
    }
}

export function setFullConsent() {
    sklikAnonymousRetargeting(true);
    setConsent(fullConsent);
    if (window?.gtag) {
        window.gtag("consent", fullConsent);
    }
    if (window?.fbq) {
        window.fbq("consent", "grant");
    }
}

const cookies = "cookies_accepted";

const pcFirst =
    "Těší nás, že jste s námi. Za účelem zlepšení funkčnosti našeho webu a poskytnutí relevantního obsahu a služeb používáme soubory cookie.";
const pcTablet =
    "Pokud souhlasíte s používáním souborů cookie, klikněte na tlačítko „Přijmout vše“. Pro více informací o tom, jak zpracováváme osobní údaje a používáme soubory cookie si prosím přečtěte naše";
const mobileText =
    "Pokud souhlasíte s používáním souborů cookie, klikněte na tlačítko „Přijmout vše“. Pro více informací si prosím přečtěte naše";
const allEndText = (
    <>
        {" "}
        {/*<Box
            component={Link}
        to='/cookies'
            target="_blank"
            rel="noreferrer"
            style={{ color: "white" }}
        >
            Zásady ochrany osobních údajů
        </Box>{" "}
        a{" "}*/}
        <Box
            component={Link}
            to='/cookies'
            target="_blank"
            rel="noreferrer"
            style={{ color: "white" }}
        >
            Cookies policy
        </Box>
    </>
);


function acceptCookies(all = false) {
    if (!localStorage) return;
    localStorage.setItem(cookies, all ? "all" : "true");
}

export function wasCookieBarClicked() {
    if (!localStorage) return true;
    return Boolean(localStorage?.getItem(cookies) === "all");
}

export function areCookiesAccepted() {
    if (!localStorage || localStorage.getItem(cookies) == null) {
        return true;

    }
    return Boolean(localStorage?.getItem(cookies) === "all");
}

function acceptedThisSession() {
    try {
        if (!sessionStorage) return false;
        return sessionStorage.getItem("cookies_session") === "true";
    } catch (error) {
        return false;
    }
}

function acceptSession() {
    try {
        if (!sessionStorage) return;
        sessionStorage.setItem("cookies_session", "true");
    } catch (e) {
        return;
    }
}

export default function CookieBar({ open, setOpen }) {
    const [shown, setShown] = useState(
        open !== undefined ? open : !wasCookieBarClicked()
    );
    const mobile = useMediaQuery(theme.breakpoints.only("xs"));
    const tablet = useMediaQuery(theme.breakpoints.only("sm"));

    useEffect(() => {
        if (open !== undefined && shown != open) {
            setShown(open);
        }
    }, [open]);

    if (acceptedThisSession()) return <></>;

    return (
        <Box
            sx={{
                width: "100%",
                maxHeight: shown ? "220px" : "0px",
                position: "fixed",
                bottom: 0,
                zIndex: 10020,
                boxShadow: "0px -2px 5px 0px rgba(115,117,122,0.2)",
                transition: "max-height .4s ease-in-out",
                textAlign: "left",
                minWidth: '380px'
            }}
        >
            <Box
                sx={{
                    minHeight: "100px",
                    bgcolor: "rgba(255, 178, 90, 0.8)",
                    opacity: 1,
                    display: "flex",
                    flexDirection: "row",
                }}
            >
                <Typography sx={{ color: "white", mx: "20px", my: "20px", fontSize: '13px' }}>
                    {!(mobile || tablet) ? <>{pcFirst} </> : ""}
                    {mobile ? mobileText : pcTablet}
                    {allEndText}
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        alignContent: "center",
                        ml: "auto",
                        mr: "20px",
                        mt: "20px",
                    }}
                >
                    <Motion scale={1.03}>
                        <Box
                            sx={{
                                minWidth: "120px",
                                height: "36px",
                                bgcolor: pastelOrange,
                                //border: `2px solid ${lightGreen}`,
                                borderRadius: "20px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                alignContent: "center",
                                cursor: "pointer",
                                opacity: 1,
                            }}
                            onClick={() => {
                                setFullConsent();
                                acceptCookies(true);
                                if (setOpen) setOpen(false);
                                setShown(false);
                            }}
                        >
                            <Typography sx={{ mt: '2px', fontFamily: 'inter', color: 'white', fontWeight: 'bold', fontSize: '14px' }} >
                                Přijmout vše
                            </Typography>
                        </Box>
                    </Motion>
                    <Typography
                        sx={{
                            color: "white",
                            mt: "12px",
                            cursor: "pointer",
                            fontSize: '13px',
                            fontFamily: 'inter'
                        }}
                        variant="button_text"
                        onClick={() => {
                            setDefaultConsent();
                            acceptCookies();
                            acceptSession();
                            if (setOpen) setOpen(false);
                            setShown(false);
                        }}
                    >
                        Jen nezbytné
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
